<script lang="ts" setup>
import type { Category } from '@consumer/logic/v2/header'
import BuyAGift from '@consumer/modules/v2/layout/Header/BuyAGift.vue'

withDefaults(defineProps<{
  category: Category
}>(), {  })
</script>

<template>
  <div class="absolute left-1/2 transform -translate-x-1/2 z-navbar" style="top: 100%;">
    <Transition
      mode="out-in"
      enterActiveClass="transition duration-50 ease-in-out transform origin-top"
      enterFromClass="scale-y-0 opacity-0"
      enterToClass="scale-y-1 opacity-100"
      leaveActiveClass="transition duration-150 ease-in-out transform"
      leaveFromClass="scale-y-1 opacity-100"
      leaveToClass="scale-y-0 opacity-0"
    >
      <div v-show="category" class="py-3" style="min-width: 1024px;">
        <V2List
          v-if="category"
          :rows="4"
          class="mx-auto w-min transition transition-all transform duration-500 ease-linear w-auto"
        >
          <V2ListItem
            v-for="subCategory in category.links"
            :key="subCategory.name"
            as="a"
            :href="subCategory.path"
            :label="subCategory.name"
            :icon="subCategory.icon"
            :image="subCategory.image"
            style="width: 248px;"
          />
          <li v-if="category.buyAGift" class="row-span-4">
            <BuyAGift
              :label="category.buyAGift.label"
              :path="category.buyAGift.path"
              :image="category.buyAGift.image"
            />
          </li>
        </V2List>
      </div>
    </Transition>
  </div>
</template>
